import {IDocument, IFile} from "@/store/step3";

export function isDopDoc(doc: IDocument): boolean {
    return !doc.files.length && !!doc.requirements.length;
}

export function isRequirementFile(doc: IDocument): boolean {
    return doc.files.some(file => isRequirementUpload(file));
}

export function isRequirementUpload(file: IFile): boolean {
    return !!file.requirement && !file.requirement.completed;
}

export const getFileType = (file: IFile): string =>  file.name.toLowerCase().split('.').pop() || '';
